import React, { useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';

import { useFetch } from '../../hooks/useFetch';
import { productsApi } from '../../api/product';

import Section from '../../components/layout/Section';
import ProductsWrapper from './ProductsWrapper';

import { Medium } from '../../components/UI/Text';
import { FONT } from '../../styles/color';
import MainBody from '../../components/layout/MainBody';
import { PRODUCTS_CATEGORIES, PRODUCTS_BANNERS } from '../../api/constant';

const BannerWrapper = styled.div`
	width: 100%;
	max-width: 1060px;
	height: 350px;

	box-sizing: border-box;
`;

const EmptyWrapper = styled.div`
	width: 100%;
	height: 300px;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export default function ProductsPage(props) {
	const { category: propCategory } = useParams();
	const navigate = useNavigate();
	
	const category = useMemo(() => {
		switch (propCategory) {
			case 'drink':
				return PRODUCTS_CATEGORIES.DRINK;
			case 'take-out':
				return PRODUCTS_CATEGORIES.TAKE_OUT;
			case 'food-container':
				return PRODUCTS_CATEGORIES.FOOD_CONTAINER;
			default:
				return PRODUCTS_CATEGORIES.DRINK;
			}
	}, [propCategory]);

	const {data, loading, error} = useFetch(productsApi.getProducts, [category]);

	if(loading) {
		return ;
	}

	if(error) {
		alert('상품 정보를 불러오는 도중에 오류가 발생했습니다.');
		navigate('/');
		return ;
	}

	const items = Array.isArray(data) ? data : [];

	return (
		<MainBody>
			<Section>
				<BannerWrapper>
					<img src={ PRODUCTS_BANNERS[category] } alt="Banner" style={{ width: '100%', height: '100%' }} />
				</BannerWrapper>
				{
					items.length !== 0 ? 
					<ProductsWrapper products={items} /> :
					<EmptyWrapper>
						<Medium size="24px" color={ FONT.deep01 }>준비된 상품이 없습니다.</Medium>
					</EmptyWrapper>
				}
			</Section>
		</MainBody>
  	);
}